module.exports = __webpack_public_path__ + "static/media/hero-3d.506bce85.png";